import { footerColumns, siteName } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1.4fr)_repeat(3,minmax(0,1fr))]">
          {/* brand */}
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                78
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {siteName}
                <span className="ml-1 text-[11px] font-normal text-foreground-500">资讯</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              78 动漫资讯频道每日更新动漫新闻与速报，覆盖新番情报、作品评测等丰富内容，是追番党与补番党的每日必看。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-rss-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {/* link columns */}
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-black text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © 2026 {siteName} · 本站内容为资讯展示用途，动漫作品版权归原作者所有
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
            <a href="#top" className="transition-colors hover:text-primary-600">
              服务条款
            </a>
            <a href="#top" className="transition-colors hover:text-primary-600">
              隐私政策
            </a>
            <a href="#subscribe" className="transition-colors hover:text-primary-600">
              联系编辑部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}